module.exports = __webpack_public_path__ + "static/media/icono_favoritos.c1fdde41.svg";